export const EmailCheck = (value) => {
  let emailCheck = {};
  const emailCond =
    /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

  if (!value) {
    return (emailCheck = {
      input: "empty",
      err_display: "Email is required!",
    });
  } else if (emailCond.test(value) === false) {
    return (emailCheck = {
      input: "invalid",
      err_display: "Enter a valid email address!",
    });
  }
  return (emailCheck = {
    validition: true,
  });
};

export const FirstNameCheck = (value) => {
  let firstNameCheck = {};

  if (!value) {
    return (firstNameCheck = {
      input: "empty",
      err_display: "First Name is required!",
    });
  }
  return (firstNameCheck = {
    validition: true,
  });
};

export const MetaTitleCheck = (value) => {
  let metaTitleCheck = {};

  if (!value) {
    return (metaTitleCheck = {
      input: "empty",
      err_display: "Meta Title is required!",
    });
  }
  return (metaTitleCheck = {
    validition: true,
  });
};

export const MetaDescriptionCheck = (value) => {
  let metaDescriptionCheck = {};

  if (!value) {
    return (metaDescriptionCheck = {
      input: "empty",
      err_display: "Meta Title is required!",
    });
  }
  return (metaDescriptionCheck = {
    validition: true,
  });
};

export const LastNameCheck = (value) => {
  let lastNameCheck = {};

  if (!value) {
    return (lastNameCheck = {
      input: "empty",
      err_display: "Last Name is required!",
    });
  }
  //  else if (/^[A-Za-z]+$/.test(value) === false) {
  //   return (lastNameCheck = {
  //     input: "invalid",
  //     err_display: "Enter the Characters!",
  //   });
  // }
  return (lastNameCheck = {
    validition: true,
  });
};

export const MobileNumberCheck = (value) => {
  let mobileNumberCheck = {};
  // const mobileCond =
  //   /^(\+?1\s?)?((\([0-9]{3}\))|[0-9]{3})[\s\-]?[\0-9]{3}[\s\-]?[0-9]{4}$/;
  const mobileCond = /^\d+$/;

  if (!value) {
    return (mobileNumberCheck = {
      input: "empty",
      err_display: "Mobile number is required!",
    });
  } else if (mobileCond.test(value) === false) {
    return (mobileNumberCheck = {
      input: "invalid",
      err_display: "Please enter a valid mobile number!",
    });
  } else if (value?.length < 10) {
    return (mobileNumberCheck = {
      input: "less",
      err_display: "Please enter a valid mobile number!",
    });
  }
  return (mobileNumberCheck = {
    validition: true,
    success_display: "Successful!",
  });
};

export const onlyNumberCheck = (value) => {
  let numberCheck = {};
  const numberCond = /^[0-9\b]+$/;

  if (!value) {
    return (numberCheck = {
      input: "empty",
      err_display: "Please enter the field!",
    });
  }
  if (numberCond.test(value) === false) {
    return (numberCheck = {
      input: "invalid",
      err_display: "Enter number only!",
    });
  }
  return (numberCheck = {
    validition: true,
    err_display: "",
  });
};

export const OtpCheck = (value) => {
  let otpCheck = {};
  if (!value) {
    return (otpCheck = {
      input: "empty",
      err_display: "Please Enter the One-time verification code!",
    });
  } else if (value.length < 6) {
    return (otpCheck = {
      input: "LessCharacters",
      err_display: "Please enter all the 6 digits!",
    });
  }
  return (otpCheck = {
    validition: true,
    status: "Successful!",
  });
};

export const CreatePasswordCheck = (value) => {
  let createPasswordCheck = {};
  // const passwordCond = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{6,16}$/;
  const passwordCond =
    /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[^A-Za-z0-9]).{8,}$/;

  if (!value) {
    return (createPasswordCheck = {
      input: "empty",
      err_display: "Create a Password!",
    });
  } else if (value.length < 8) {
    return (createPasswordCheck = {
      input: "lesscharacters",
      err_display:
        "Should contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character!",
    });
  } else if (passwordCond.test(value) === false) {
    return (createPasswordCheck = {
      input: "invalid",
      err_display:
        "Should contain at least 8 characters, one uppercase letter, one lowercase letter, one number and one special character!",
    });
  }
  return (createPasswordCheck = {
    validition: true,
  });
};

export const ConfirmPasswordCheck = (value1, value2) => {
  let confirmPasswordCheck = {};

  if (!value2) {
    return (confirmPasswordCheck = {
      input: "empty",
      err_display: "Confirm the Password!",
    });
  } else if (value1 != value2) {
    return (confirmPasswordCheck = {
      input: "deosnotmatch",
      err_display: "Password did not match!",
    });
  }
  return (confirmPasswordCheck = {
    validition: true,
  });
};

export const AddressCheck = (val) => {
  let addressCheck = {};

  if (!val) {
    return (addressCheck = {
      input: "empty",
      err_display: "Enter Business Address!",
    });
  } else if (val.length > 225) {
    return (addressCheck = {
      input: "maxCharacters",
      err_display: "Entered maximum characters!",
    });
  }
  return (addressCheck = {
    validition: true,
  });
};

export const ZipCodeCheck = (val) => {
  let ZipCodeCheck = {};
  const zipCodeRegex = /^(?:\d{5,10}|\d{1,5}-\d{1,5})$/;
  if (!val) {
    return (ZipCodeCheck = {
      input: "empty",
      err_display: "Please enter the Zipcode!",
    });
  } else if (val.length > 11) {
    return (ZipCodeCheck = {
      input: "invalid",
      err_display: "Please enter the valid zipcode!",
    });
  } else if (zipCodeRegex.test(val) === false) {
    return (ZipCodeCheck = {
      input: "Characters",
      err_display: "Please enter the valid zipcode!",
    });
  }
  return (ZipCodeCheck = {
    validition: true,
  });
};

export const SocialMediaCheck = (val) => {
  let SocialMediaCheck = {};
  const SocialMedia = new RegExp(
    "(https?://)?([\\da-z.-]+)\\.([a-z.]{2,6})[/\\w .-]*/?"
  );

  if (!val) {
    return (SocialMediaCheck = {
      input: "empty",
      err_display: "Please enter the Field!",
    });
  } else if (SocialMedia.test(val) === false) {
    return (SocialMediaCheck = {
      input: "invalid",
      err_display: "Please enter the valid Url!",
    });
  }
  return (SocialMediaCheck = {
    validition: true,
  });
};
